import * as PropTypes from 'prop-types';
import NotificationReceiver from './NotificationReceiver';
import withNotification from './withNotification';

const NotificationPropTypes = PropTypes.shape({
  setMessage: PropTypes.func.isRequired,
});

export { NotificationReceiver, withNotification, NotificationPropTypes };
